<script setup lang="ts">
import { RowInfo } from '@shared/ui/other'

import { useMainInfoCategory } from '../../model/use-main-info-category.hook'

defineOptions({
  name: 'MainInfoCategory',
})

const { refValue } = useMainInfoCategory()
</script>

<template>
  <RowInfo
    title="Category"
    :value="refValue"
  />
</template>
